module.exports = __webpack_public_path__ + "04e98068c1bc112613dc9c04393527dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/201605_Presse_AVANGA_Sputnika_1_479KB.jpg
// module id = 567
// module chunks = 0